import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoText } from 'components/no-auth/common/PromoText/PromoText';
import BasePage from 'components/utils/BasePage';

import { URL_IMAGES_I } from 'constants/UrlConstants';

import promoMedia from 'theme/promoMedia';

const BrowserHeader = styled.div`
    margin-bottom: 1em;
`;
const IconStatus = styled.div`
    margin-bottom: 24px;

    img {
        border: none;
        vertical-align: top;
    }
`;
const BrowserLinks = styled.div`
    margin-top: 46px;
    text-align: center;

    a {
        &:hover,
        &:link,
        &:visited {
            outline: none;
            text-decoration: none;
        }
    }

    img {
        border: none;
        margin-left: 8px;
        margin-right: 8px;
        vertical-align: top;
    }
`;
const Inner = styled.div`
    text-align: center;
    width: 100%;
`;
const Placeholder = styled.div`
    align-items: center;
    display: flex;
    height: calc(100vh - 120px);
    justify-content: center;
    min-height: 260px;

    ${promoMedia.tablet744} {
        height: calc(100vh - 256px);
    }

    ${promoMedia.desktop1440} {
        min-height: 271px;
    }
`;
const OldBrowsersPage = (props) => {
    const browserLogos = props.browsers.map((browserLogo) => {
        return { imgSrc: browserLogo.Icon.data.attributes.url, linkHref: browserLogo.link, browserTitle: browserLogo.Name };
    });
    return (
        <ColoredSectionContainer>
            <Placeholder>
                <Inner>
                    <IconStatus>
                        <img src={`${URL_IMAGES_I}/x-in-circle.jpg`} alt="" />
                    </IconStatus>
                    <BrowserHeader>
                        <PromoText color={'baseColor'} variant={'subheader'}>
                            {props.browserHeaderText}
                        </PromoText>
                    </BrowserHeader>
                    <PromoText color={'gray40'} tag={'div'}>
                        {props.browserText}
                    </PromoText>
                    <BrowserLinks>
                        {browserLogos.map((logo, index) => {
                            const { imgSrc, linkHref, browserTitle } = logo;
                            return (
                                <a key={`${logo}${index}`} href={linkHref} target="_blank">
                                    <img src={imgSrc} alt={browserTitle} />
                                </a>
                            );
                        })}
                    </BrowserLinks>
                </Inner>
            </Placeholder>
        </ColoredSectionContainer>
    );
};
const mapStateToProps = (state) => {
    return {
        browserHeaderText: state.extra?.browsers_page?.data?.attributes?.headerText,
        browserText: state.extra?.browsers_page?.data?.attributes?.description,
        browsers: state?.extra?.browsers_page?.data?.attributes?.Browsers,
    };
};
export default connect(mapStateToProps)(BasePage(OldBrowsersPage));
